import { formatDate } from '@angular/common';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const toDate = (d: NgbDateStruct) => new Date(d.year, d.month - 1, d.day);

/**
 * Label for a date-range filter input:
 * - same year: `1 Oct – 31 Oct 2026`
 * - different years: `1 Oct 2025 – 31 Oct 2026`
 * - a single day (from === to, or only `from`): `1 Oct 2026`
 */
export function formatDateRangeLabel(from: NgbDateStruct, to: NgbDateStruct | null): string {
  const start = toDate(from);
  if (!to || (to.year === from.year && to.month === from.month && to.day === from.day)) {
    return formatDate(start, 'd MMM y', 'en-US');
  }
  const end = toDate(to);
  const startFormat = from.year === to.year ? 'd MMM' : 'd MMM y';
  return `${formatDate(start, startFormat, 'en-US')} – ${formatDate(end, 'd MMM y', 'en-US')}`;
}
